import { useEffect } from 'react'
import {
  FulfilmentDetail,
  FulfilmentType,
} from '../../../../../../models/fulfilment'
import {
  CurrentView,
  useLineItemFulfillmentContext,
} from '../LineItemFulfillmentContext'

export const useLineItemFulfillmentDetailsChange = () => {
  const {
    currentView,
    fulfilmentDetails,
    setFulfilmentDetails,
    setCurrentView,
  } = useLineItemFulfillmentContext()

  useEffect(() => {
    // When entering the Fulfillment Method view, default to Delivery if the fulfillment type is unspecified
    if (
      currentView === CurrentView.FULFILMENT_METHOD &&
      fulfilmentDetails.type === FulfilmentType.UNSPECIFIED
    ) {
      setFulfilmentDetails((state: FulfilmentDetail) => ({
        ...state,
        type: FulfilmentType.DELIVERY,
      }))
    }
  }, [currentView, fulfilmentDetails, setFulfilmentDetails])

  const handleSelectFulfillmentType = (type: FulfilmentType) => {
    setFulfilmentDetails((state: FulfilmentDetail) => ({
      ...state,
      type,
    }))

    // Address correction only applies to Delivery. Returning to the method
    // view lets the cashier switch to Pickup, then reopens address correction
    // if they switch back to Delivery and continue.
    if (currentView === CurrentView.FIX_SALE_ADDRESSES) {
      setCurrentView(CurrentView.FULFILMENT_METHOD)
    }
  }

  const handleNoteChange = (note: string) => {
    setFulfilmentDetails((state: FulfilmentDetail) => ({ ...state, note }))
  }

  return {
    handleSelectFulfillmentType,
    handleNoteChange,
  }
}
